export const isEven = n => {
  let ans = false
  if ((n + 1) % 2 === 0) {
    ans = true
  }
  return ans
}
